export default __webpack_public_path__ + "static/media/animated-web-template.40bd9a12.png";